import { render, staticRenderFns } from "./OpenCreation.vue?vue&type=template&id=fda235fc&scoped=true&"
import script from "./OpenCreation.vue?vue&type=script&lang=js&"
export * from "./OpenCreation.vue?vue&type=script&lang=js&"
import style0 from "./OpenCreation.vue?vue&type=style&index=0&id=fda235fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda235fc",
  null
  
)

export default component.exports